import {api} from "./_ApiFactoryWithHeader";

export const apiClient = {
    getClients: (params) => {
        return api.get('clients', params, null)
    },
    getClientDetail: (id, params) => {
        return api.get(`clients/${encodeURIComponent(id)}`, params, null)
    },
    getClientDetailByTenantMemberId: (tenantMemberId, clientParams) => {
        return api.get(`tenant_members/${encodeURIComponent(tenantMemberId)}`, {
            $select: 'client'
        }).then(res => {
            if (res && res.status === 200 && res.data) {
                const clientId = res.data.client;
                return apiClient.getClientDetail(clientId, clientParams);
            } else {
                return res;
            }
        });
    },
    addClient: (body) => {
        return api.post(`clients`, body)
    },
    updateClient: (id, body) => {
        return api.put(`clients/${encodeURIComponent(id)}`, body)
    },
    updateClientWithPost: (id, body) => {
        return api.post(`clients/${encodeURIComponent(id)}`, body)
    },
    deleteClient: (id, params) => {
        return api.delete(`clients/${encodeURIComponent(id)}`, params);
    },
    getCreditHistories: (params) => {
        return api.get(`credit-histories`, params, null)
    },
    addCredit: (body) => {
        return api.post(`credits`, body)
    },
    exportCredit: (clientId, params) => {
        return api.getXlsxFile(`credits-export/${encodeURIComponent(clientId)}`, params, null)
    }

};
